// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3RP4P","label":"Completed_label__2FkJz"};